if(!customElements.get("animate-circle")) {
    class AnimateCircle extends HTMLElement {
      // Animation configuration constants
      static ANIMATION_CONFIG = {
        INTERSECTION_THRESHOLD: 0.6,
        CIRCLE_STAGGER_DELAY: 1000,
        TEXT_REVEAL_DELAY: 500,
        ACTIVE_CLASS: "show",
      };
    
      constructor() {
        super();
        this.observer = null;
      }
    
      /**
       * Called when element is inserted into DOM
       */
      connectedCallback() {
        this.circleItems = this.querySelectorAll("[js-circle]");
    
        if (this.circleItems.length === 0) {
          console.warn("No circle items found in <animate-circle>");
          return;
        }
    
        this.config = this._loadConfiguration();
        this._initializeIntersectionObserver();
      }
    
      /**
       * Called when element is removed from DOM
       */
      disconnectedCallback() {
        if (this.observer) {
          this.observer.disconnect();
        }
      }
    
      /**
       * Load configuration from data attributes or use defaults
       * @private
       * @returns {Object} Configuration object
       */
      _loadConfiguration() {
        return {
          intersectionThreshold:
            parseFloat(this.dataset.threshold) ||
            AnimateCircle.ANIMATION_CONFIG.INTERSECTION_THRESHOLD,
          staggerDelay:
            parseInt(this.dataset.staggerDelay) ||
            AnimateCircle.ANIMATION_CONFIG.CIRCLE_STAGGER_DELAY,
          textDelay:
            parseInt(this.dataset.textDelay) ||
            AnimateCircle.ANIMATION_CONFIG.TEXT_REVEAL_DELAY,
          activeClass:
            this.dataset.activeClass ||
            AnimateCircle.ANIMATION_CONFIG.ACTIVE_CLASS,
        };
      }
    
      /**
       * Initialize the Intersection Observer for scroll-triggered animation
       * @private
       */
      _initializeIntersectionObserver() {
        const observerOptions = {
          threshold: this.config.intersectionThreshold,
        };
    
        const observerCallback = (entries, observer) => {
          const [entry] = entries;
    
          if (!entry.isIntersecting) return;
    
          this._executeAnimationSequence();
          observer.disconnect();
        };
    
        this.observer = new IntersectionObserver(observerCallback, observerOptions);
        this.observer.observe(this);
      }
    
      /**
       * Execute the staggered animation sequence for all circle items
       * @private
       */
      _executeAnimationSequence() {
        this.circleItems.forEach((circleItem, circleIndex) => {
          const secondaryTextElement = circleItem.querySelector(
            "[js-circle-secondary-text]"
          );
          const circleDelay = circleIndex * this.config.staggerDelay;
    
          setTimeout(() => {
            this._animateCircleItem(circleItem, secondaryTextElement, circleIndex);
          }, circleDelay);
        });
      }
    
      /**
       * Animate a single circle item and its secondary text
       * @private
       * @param {HTMLElement} circleItem - The circle container element
       * @param {HTMLElement|null} secondaryTextElement - The secondary text element
       */
      _animateCircleItem(circleItem, secondaryTextElement, circleIndex) {
        circleItem.classList.add(this.config.activeClass);
    
        if (secondaryTextElement) {
          setTimeout(() => {
            secondaryTextElement.classList.add(this.config.activeClass);
          }, this.config.textDelay);
        }
        setTimeout(() => {
            this.querySelectorAll('[js-circle-svg]')[circleIndex].classList.add(this.config.activeClass);
        }, this.config.textDelay)
      }
    
      /**
       * Observed attributes for attribute change callbacks
       */
      static get observedAttributes() {
        return ["data-threshold", "data-stagger-delay", "data-text-delay", "data-active-class"];
      }
    
      /**
       * Called when observed attributes change
       */
      attributeChangedCallback(name, oldValue, newValue) {
        if (oldValue !== newValue && this.isConnected) {
          this.config = this._loadConfiguration();
        }
      }
    }
    
    // Define the custom element
    customElements.define("animate-circle", AnimateCircle);
}
